import React from 'react';

export default function CheckinBerkala() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Check-in Berkala</h1>
      <p className="text-gray-500">Halaman Check-in Berkala</p>
    </div>
  );
}
